
export const COLUMNS1 = [
  // {
  //   Header: "",
  //   accessor: "colorCoding",
  //   Cell: (props: any) => {
  //     return (
  //       <div
  //         className="color-code-consultant"
  //         style={{
  //           // color: `{props.value}`,
  //           width: "100px",
  //           height: "100px",
  //           backgroundColor: props.value,
  //           borderRadius: "10px 0 0 10px",
  //           marginLeft: "-20px",
  //         }}
  //       >
  //         <img
  //           src={"assets/images/directoryIcon.svg"}
  //           width={100}
  //           height="fit-content"
  //           style={{
  //             width: "29px",
  //             height: "32px",
  //             marginTop: "27px",
  //             marginLeft: "10px",
  //             fill: "white !important",
  //           }}
  //           alt=" "
  //         />
  //         {/* <FontAwesomeIcon
  //           style={{ color: "#F8F0E3", marginTop: "22px", fontSize: '50px' }}
  //           icon={faFileAlt}
  //         /> */}
  //       </div>
  //     )
  //   },
  // },
  // {
  //   Header: "ID",
  //   accessor: "mocId",
  // },
  {
    Header: "Name",
    accessor: "consultantName",
  },
  {
    Header: "Specialization",
    accessor: "specialization",
  },

  {
    Header: "Phone Number",
    accessor: "phoneNumber",
  },
  {
    Header: "Email",
    accessor: "emailId",
  },
]
